import React, { useEffect, useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { deploymentTypes, servers, serverType } from "../deployment-config";
import axios from "../axios";
import useLogout from "../hooks/useLogout";
import { LoadingButton } from "../Utils/CustomComponent";
let server_address =
  serverType === deploymentTypes.development
    ? servers.development
    : deploymentTypes.localDevelopment
    ? servers.localDevelopment
    : servers.production;
const environment_hostname = "https://" + server_address + "/api/v1";
const TimeoutModal = () => {
  const logout = useLogout();
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [hold, setHold] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);

  const masqueradeEmail = useSelector(
    (state) => state.RS_Authentication.masquerade
  );

  useInactivityTimeout(900000, () => {
    setShowTimeoutModal(true); // 15 min = 900000 ms
  });
  // useEffect(() => {
  //   // Start a timer for 15 minutes after login
  //   const timer = setTimeout(() => {
  //     setShowTimeoutModal(true); // Show the modal after 15 minutes
  //   }, 900000); // 15 minutes

  //   return () => clearTimeout(timer); // Clean up the timer
  // }, []);

  useEffect(() => {
    let countdownTimer;
    if (showTimeoutModal) {
      // Start a 30-second countdown when the modal is shown
      countdownTimer = setInterval(() => {
        setCountdown((prevCount) => prevCount - 1);
      }, 1000);

      if (hold) {
        clearInterval(countdownTimer);
      }
    }

    return () => clearInterval(countdownTimer); // Clean up the interval
  }, [showTimeoutModal, hold]);

  useEffect(() => {
    if (countdown === 0 && !hold) {
      // Logic to log the user out
      logout();
    }
  }, [countdown, logout, hold]);

  const extendSession = async () => {
    setDisableBtn(true);
    setHold(true);
    try {
      const response = await axios.post(
        `${environment_hostname}/auth/masquerade`,
        {
          p_logged_in_email: masqueradeEmail.p_logged_in_email,
          p_session: masqueradeEmail.p_session,
          p_ticket_id: masqueradeEmail.p_ticket_id,
          p_customer_contact_id: masqueradeEmail.p_customer_contact_id,
        }
      );

      // Handle successful response
      if (response?.data?.userid) {
        // Reset the countdown and hide the modal
        setCountdown(30);
        setShowTimeoutModal(false);
      } else {
        // Handle scenarios where the extension is unsuccessful
        console.error("Session extension failed", response);
        logout();
      }
    } catch (error) {
      // Handle error scenarios
      console.error("Error extending session", error);
      logout();
    } finally {
      setDisableBtn(false);
      setHold(false);
    }
  };
  return (
    <Modal show={showTimeoutModal} onHide={() => logout()} backdrop='static'>
      <Modal.Header closeButton>
        <Modal.Title>Session Timeout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>You will be logged out in {countdown} seconds.</p>
        <p>Do you want to continue your session?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={logout}>
          Cancel
        </Button>
        {/* <Button variant="primary" onClick={extendSession}>
          Extend
        </Button> */}
        <LoadingButton
          className="btn btn-primary text-white"
          type="button"
          onClick={extendSession}
          title={"Extend"}
          disabled={disableBtn}
          loading={disableBtn}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default TimeoutModal;

function useInactivityTimeout(timeout = 900000, onTimeout) {
  const timerRef = useRef(null);

  useEffect(() => {
    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        onTimeout(); // Show modal or handle timeout
      }, timeout);
    };

    // Events that indicate user activity
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];

    // Attach event listeners
    events.forEach(event => window.addEventListener(event, resetTimer));

    // Start initial timer
    resetTimer();

    // Cleanup on unmount
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [timeout, onTimeout]);
}